export const GET_USER_KYC_INFO = '/api/v1/user/kyc/brief';
export const UPLOAD_IDENTITY_PIC = '/api/v1/user/kyc/upload/identity-pic';
export const UPLOAD_SELFIE = '/api/v1/user/kyc/upload/selfie';
export const SUBMIT_KYC = '/api/v1/user/kyc/submit';
export const UPDATE_ADDRESS = '/api/v1/user/kyc/batch-two/address';
export const SERVE_USER_FILES = '/api/v1/user/kyc/serve/user';
export const SUBMIT_NATIONALID = '/api/v1/user/kyc/one/nationalid';
export const UPLOAD_IDENTITY_CARD =
  '/api/v1/user/kyc/upload/identity-card-optional';
export const IS_REQUIRED_OPTIONAL_IDENTITY =
  '/api/v1/user/kyc/config/is-required';
